<!-- LAYOUT -->
<app-toast-container />

<lib-w-h-main-layout
  class="cdk-border"
  data-cy="main-layout"
  [quickNavItemDOM]="quickNavItemDOM"
  [helpNavItemDOM]="helpNavItemDOM"
  [layoutConfigDOM]="layoutConfigDOM"
  [layoutNavItemDOMList]="layoutNavItemDOMList"
  [layoutLanguageDOMList]="layoutLanguageDOMList"
  [layoutMobileNavItemDOMList]="layoutMobileNavItemDOMList"
  [layoutLoggedInUserDOM]="layoutLoggedInUserDOM"
  [layoutLogoDOM]="layoutLogoDOM"
  [navItemLimit]="7"
  [isMobileMenuVisible]="isSmallScreen()"
  [layoutLoggedInUserNavItemDOMList]="layoutLoggedInUserNavItemDOMList"
  (onDomEvent)="onDomChildEvent($event)"
>
  @if (isAiFeatureEnabled()) {
    <div class="m-r--8">
      <app-wh-ai-button />
    </div>
  }
</lib-w-h-main-layout>
